module.exports = __webpack_public_path__ + "img/twp.eb47c426.png";